export default __webpack_public_path__ + "static/notification-6c9a217c3a00b578115ab7d00f9f9f26.png";